module.exports = __webpack_public_path__ + "img/coach.d8ee0c60.svg";